module.exports = __webpack_public_path__ + "static/media/slot4.35f194bb.jpg";